// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.\\------packages-components-bot-semi-src-components-ui-form-input-index-module__field-iFwQb0 {
  padding-bottom: 24px !important;
}

div.\\------packages-components-bot-semi-src-components-ui-form-input-index-module__field-iFwQb0:has(.semi-form-field-error-message) {
  padding-bottom: 0 !important;
}

div.\\------packages-components-bot-semi-src-components-ui-form-input-index-module__field-iFwQb0 .semi-form-field-error-message {
  margin-top: 4px;
  margin-left: var(--var-error-msg-offset);
  word-break: break-word;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `------packages-components-bot-semi-src-components-ui-form-input-index-module__field-iFwQb0`
};
export default ___CSS_LOADER_EXPORT___;
